module.exports = "<div style=\"width:100%;height:20px;border-bottom:1px solid grey;\"></div>\n\n<div class=\"graph-main-container\">\n    <div class=\"graph-container\">\n        <p-chart #mainChart [type]=\"graphType\" [options]=\"graphOptions\" [data]=\"data\"></p-chart> \n    </div>\n    <div class=\"dimos-name\"> <span style=\"font-size:11pt;color:#444;\">ΔΗΜΟΣ:</span> {{data.props.name}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/graph/graph.component.html
// module id = ../../../../../src/app/components/graph/graph.component.html
// module chunks = main